import React from 'react';
import PropTypes from 'prop-types';
import styles from './CustomShareChgComponent.module.css'
import upArrow from '../../../assets/SVGs/UpwardsIcon.svg'
import downArrow from '../../../assets/SVGs/DownwardsIcon.svg'

 const CustomShareChgComponent = (props) => {
    const value = parseFloat(props?.value);
    const renderClass = value >= 0 ? `${styles.positiveValue} ${styles.defaultValue}` : `${styles.negativeValue} ${styles.defaultValue}`;
    const arrow = value >= 0 ? upArrow : downArrow;
    const absValue = Math.abs(value);
    const formattedValue = absValue.toLocaleString('en-US', { maximumFractionDigits: 3 });

    return (
        <div className={renderClass}>
           <img src={arrow} alt={'Arrow'} className={styles.arrow} /> 
           {formattedValue} bps
        </div>
    );
}

CustomShareChgComponent.propTypes = {
	value: PropTypes.any
};

export default CustomShareChgComponent